import { css } from '@emotion/css';
import { Theme } from 'src/lib/theme/types';

export const main = (theme: Theme) => css`
  padding-left: 15px;
  padding-right: 15px;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${theme.breakpoint.md.from}) {
    max-width: 750px;
  }
  @media (min-width: ${theme.breakpoint.lg.from}) {
    max-width: 970px;
  }
  @media (min-width: ${theme.breakpoint.xl.from}) {
    max-width: 1170px;
  }
`;
